export default __webpack_public_path__ + "a3bb35fccd249f8398f5adfc49fbdde8.svg";